import React from 'react'
import ContactSection from '../ContactSection'
import Map from '../Map'

const Contact = () => {
  return (
	<div>
		  <ContactSection />
		  <Map />
	</div>
  )
}

export default Contact
